import { ReactElement } from 'react';
import { type FieldValues, type UseFormReturn } from 'react-hook-form';
import { FormHelperText, Grid } from '@mui/material';

type Props<Values extends FieldValues> = {
	form: UseFormReturn<Values>;
};

const FormErrors = <Values extends FieldValues>({ form }: Props<Values>): ReactElement | null => {
	if (form.formState.errors.root == null) {
		return null;
	}

	return (
		<Grid item xs={12}>
			<FormHelperText error>{form.formState.errors.root.message}</FormHelperText>
		</Grid>
	);
};

export { FormErrors };
